import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React, { useState } from 'react'
import { DeviceModeSelect } from 'src/editor/layout/sidebar/settings/device-mode-select'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import { WebsiteLogoSettingsImage } from './website-logo-settings-image'
import { WebsiteLogoSettingsText } from './website-logo-settings-text'

export interface WebsiteLogoSettingsProps {
  entity: WebsiteLogoInterface
}

const sidebarModes = {
  text: 'text',
  image: 'image',
} as const
type SidebarMode = keyof typeof sidebarModes

export const WebsiteLogoSettings = ({ entity }: WebsiteLogoSettingsProps) => {
  const [mode, setMode] = useState<SidebarMode>(sidebarModes.text)
  return (
    <div className="mt-[-20px]">
      <DeviceModeSelect />

      <Switcher
        btnList={[
          {
            value: sidebarModes.text,
            content: 'components.core.toolbox.types.text',
          },
          {
            value: sidebarModes.image,
            content: 'components.core.toolbox.types.image',
          },
        ]}
        value={mode}
        update={setMode}
        wrapperClassName="p-0 mb-5"
      />

      {mode === sidebarModes.text ? (
        <WebsiteLogoSettingsText entity={entity} />
      ) : (
        <WebsiteLogoSettingsImage entity={entity} />
      )}

      <HtmlAttrId attrId={entity.htmlAttrId} />
    </div>
  )
}
